import { createContext, useMemo, useState } from 'react';
import type React from 'react';

type ContextType = {
  filteredByMinDown: boolean;
  setFilteredByMinDown: React.Dispatch<React.SetStateAction<boolean>>;
};

const ConditionalTileContext = createContext<ContextType>({
  filteredByMinDown: false,
  setFilteredByMinDown() {}
});

export type OwnProps = {
  filteredByMinDown?: boolean;
};

export function ConditionalTileContextProvider(
  props: React.PropsWithChildren<OwnProps>
) {
  const [filteredByMinDown, setFilteredByMinDown] = useState(
    props.filteredByMinDown ?? false
  );

  const value = useMemo<ContextType>(
    () => ({
      filteredByMinDown,
      setFilteredByMinDown
    }),
    [filteredByMinDown]
  );

  return (
    <ConditionalTileContext.Provider value={value}>
      {props.children}
    </ConditionalTileContext.Provider>
  );
}

ConditionalTileContextProvider.displayName = 'ConditionalTileContextProvider';

export default ConditionalTileContext;
